module.exports = __webpack_public_path__ + "img/favicon_old.fc63ef8d.svg";